<template>
	<section class="sk-inner-picker">
		<select class="sk-picker-field sk-picker-field-day-3" v-model="day" @change="onChange">
			<option v-for="item in collectioDay" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
		<select class="sk-picker-field sk-picker-field-month-3" v-model="month" @change="onChange">
			<option v-for="item in collectionMonth" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
		<select class="sk-picker-field sk-picker-field-year-3" v-model="year" @change="onChange">
			<option v-for="item in collectionYear" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
	</section>
</template>

<script>
import moment from 'moment'
export default {
	name: 'picker-month',
	data() {
		return {
			year: moment().year(),
			month: moment().month(),
			day: moment().date(),
			hour: 0,
			minute: 0,
		}
	},
	computed: {
		collectionYear() {
			const collection = []

			for (let value = 2000; value < 2100; value++) {
				collection.push({
					key: value,
					name: value
				})
			}

			return collection
		},
		collectionMonth() {
			const collection = []

			for (let value = 0; value < 12; value++) {
				collection.push({
					key: value,
					name: this.getMonth(value)
				})
			}

			return collection
		},
		collectioDay() {
			const collection = []

			for (let value = 0; value < 31; value++) {
				collection.push({
					key: value + 1,
					name: value + 1
				})
			}

			return collection
		}
	},
	methods: {
		onChange() {
			const endOfMonthDate = moment([this.year, this.month]).endOf('month');
			const newDate = moment([this.year, this.month, this.day]);

			if (!newDate.isValid()) {
				this.day = endOfMonthDate.date()
			}

			this.$emit('change', {
				year: this.year,
				month: this.month + 1,
				day: this.day,
				hour: this.hour,
				minute: this.minute,
			})
		},
		getMonth: (value) => moment().month(value).format('MMM')
	},
	created() {
		this.$emit('change', {
			year: this.year,
			month: this.month + 1,
			day: this.day,
			hour: this.hour,
			minute: this.minute,
		})
	}
}
</script>

<style scope>
	.sk-picker-field-day-3 {
		width: 40px;
	}
	.sk-picker-field-month-3 {
		width: 50px;
	}
	.sk-picker-field-year-3 {
		width: 60px;
	}
</style>



// WEBPACK FOOTER //
// src/modules/datetime/PickerDay.vue